import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache } from 'firebase/firestore';

export const masterFirebaseConfig = {
  apiKey: import.meta.env.VITE_MASTER_API_KEY,
  authDomain: import.meta.env.VITE_MASTER_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_MASTER_PROJECT_ID,
  storageBucket: import.meta.env.VITE_MASTER_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MASTER_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_MASTER_APP_ID,
};

export const masterApp = initializeApp(masterFirebaseConfig);
export const masterAuth = getAuth(masterApp);
export const masterDb = initializeFirestore(masterApp, {
  localCache: persistentLocalCache(),
});
